import React, { useContext, useState } from "react";

import { ReactComponent as Business } from "../../../assets/novosicones/notificacoes/business.svg";

import { ContextNotificacoes } from "../../../services/notificacoes";

import { useHistory } from "react-router-dom";

import { Spinner } from "../../StyledComponent";

const ManutencaoPeriodica = ({ tema, setNotificationsModal }) => {
  const NOTIFICATIONSMANUTENCAOPERIODICA = JSON.parse(
    sessionStorage.getItem("notificationsManutencaoPeriodica")
  );

  const [manutencaoSelecionada, setManutencaoSelecionada] = useState("");

  const {
    atualizaNotificacoes,
    marcarNotificacaoManutencaoPeriodica,
  } = useContext(ContextNotificacoes);

  const [loading, setLoading] = useState(false);

  async function marcarManutencaoComoLida(id) {
    await marcarNotificacaoManutencaoPeriodica(id);

    let temp = NOTIFICATIONSMANUTENCAOPERIODICA.filter(
      (manutencao) => manutencao.Id != id
    );
    sessionStorage.setItem(
      "notificationsManutencaoPeriodica",
      JSON.stringify(temp)
    );

    await atualizaNotificacoes();
  }

  const history = useHistory();

  function redirectToMeuImovel(empreendimentoIdSalesForce) {
    history.push({
      pathname: "/meu-imovel",
      state: {
        empreendimentoIdSalesForce,
        documentos: true,
      },
    });
  }

  const handleVisualizar = async (Id, EmpreendimentoIdSalesForce) => {
    await marcarManutencaoComoLida(Id);

    redirectToMeuImovel(EmpreendimentoIdSalesForce);

    setLoading(false);

    setNotificationsModal(false);
  };

  let checkIfNewMaintenance = [];

  if (NOTIFICATIONSMANUTENCAOPERIODICA?.length > 0)
    checkIfNewMaintenance = NOTIFICATIONSMANUTENCAOPERIODICA.filter((item) => {
      return !item.Visualisado;
    });

  if (checkIfNewMaintenance.length == 0) return null;

  return (
    <div className="notifications__item">
      {NOTIFICATIONSMANUTENCAOPERIODICA?.map((manutencao) => {
        return (
          <div className="centralized-space-between" key={manutencao.Id}>
            <div className="centralized">
              <Business style={{ fill: tema.primaryColor }} />
              <p
                className="notifications__item__description"
                style={{ color: "#454545" }}
              >
                Lembrete: É importante acessar o manual do proprietário para
                saber as datas das manutenções periódicas do seu imóvel!
              </p>
            </div>
            {loading && manutencaoSelecionada == manutencao.Id ? (
              <Spinner />
            ) : (
              <a
                style={{ color: tema.primaryColor, cursor: "pointer" }}
                onClick={() => {
                  setLoading(true);
                  setManutencaoSelecionada(manutencao.Id);
                  handleVisualizar(manutencao.Id, manutencao.EmpreendimentoId);
                }}
              >
                VISUALIZAR
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ManutencaoPeriodica;
